import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

export default function useEvaluationsList() {

    // Use toast
    const toast = useToast();

    const refEvaluationsListTable = ref(null);

	const styleColumns = {
        thClass: 'text-center',
        tdClass: 'text-center'
    }

    // Table Handlers
    let tableColumns = [
        { key: 'start_date', sortable: true, label: 'MES/AÑO <br> EVALUACIÓN' },
        { key: 'evidence_type', sortable: false, label: 'TIPO DE SOLICITUD' },
        { key: 'provider_name', sortable: true, label: 'PROVEEDOR', thClass: styleColumns.thClass, tdClass: 'text-left' },
        { key: 'state_name', sortable: true, label: 'ESTADO' },
        { key: 'condition_name', sortable: true, label: 'CONDICIÓN' },
        //{ key: 'evidence_status', sortable: false, label: 'VIGENCIA' },
        { key: 'createdAt', sortable: true, label: 'FECHA REGISTRO' },
        { key: 'actions', sortable: false, label: 'OPCIONES' }
    ];

    const perPage = ref(10);
    const totalEvaluations = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [5, 10, 15, 20];
    const sortBy = ref('createdAt');
    const isSortDirDesc = ref(true);

    const statesFilter = ref(null);
    const conditionsFilter = ref(null);

    // Default period: current month/year (full month range)
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();
    const lastDay = new Date(currentYear, currentMonth, 0).getDate();
    const defaultStartStr = `${currentYear}-${String(currentMonth).padStart(2, '0')}-01`;
    const defaultEndStr = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
    const startDateRangePickerFilter = ref(`${defaultStartStr} ${defaultEndStr}`);

    const searchQuery = ref('');

    const dataMeta = computed(() => {
        const localItemsCount = refEvaluationsListTable.value ? refEvaluationsListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalEvaluations.value,
        }
    });

    const refetchData = () => {
        refEvaluationsListTable.value.refresh();
    };

    watch([currentPage, perPage, statesFilter, conditionsFilter, startDateRangePickerFilter, searchQuery], () => {
        refetchData();
    });

    const fetchEvaluations = (ctx, callback) => {
        store
            .dispatch('app-evaluations/fetchEvaluations', {
                queryParams: {
                    perPage: perPage.value,
                    page: currentPage.value,
                    sortBy: sortBy.value,
                    sortDesc: isSortDirDesc.value,

                    states: statesFilter.value,
                    conditions: conditionsFilter.value,
                    startdate: startDateRangePickerFilter.value,
                    search: searchQuery.value
                }
            })
            .then(response => {
                const { forms, total } = response.data;
                callback(forms);
                totalEvaluations.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de evaluaciones',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            });
    };

    return {
        fetchEvaluations,
        tableColumns,
        perPage,
        currentPage,
        totalEvaluations,
        dataMeta,
        perPageOptions,
        sortBy,
        isSortDirDesc,
        refEvaluationsListTable,

        refetchData,

        // Extra Filters
        statesFilter,
        conditionsFilter,
        startDateRangePickerFilter,
        searchQuery
    }
}
